import { StyledEngineProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import initializeStore from '../store';
import { FeatureProvider } from './components/FeatureProvider';
import AppContainer from './scenes/App';

const queryClient = new QueryClient();
const store = initializeStore();

const App = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <FeatureProvider>
          <AppContainer />
        </FeatureProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  </Provider>
);

export default App;
